import gql from 'graphql-tag';

export default gql`
  fragment callStepFragment on CallStep {
    id
    actionsCount
    calledCount
  }
`;
